// extracted by mini-css-extract-plugin
module.exports = {"arrow-btn-box":"O","arrowBtnBox":"O","arrow-btn-wrap-box":"P","arrowBtnWrapBox":"P","arrow-btn-text":"Q","arrowBtnText":"Q","arrow-btn-arrow":"R","arrowBtnArrow":"R"};